module.exports = __webpack_public_path__ + "img/bim (7).87b8c025.png";